module.exports = __webpack_public_path__ + "img/curso_3_texto.7e06f71b.png";